import type { CSSProperties } from 'styled-components';
import styled from 'styled-components';

import marketCredit from '#src/assets/market-credit.svg';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';

const Root = styled(Horizontal).attrs({ center: true })`
  --percentage: 0%;

  width: var(--quadruple-unit);
  height: var(--quadruple-unit);
  aspect-ratio: 1;
  border-radius: 50%;

  border: 2px solid transparent;
  background:
    conic-gradient(
        var(--c-nl-500) var(--percentage),
        var(--c-nd-50) var(--percentage)
      )
      padding-box,
    conic-gradient(#87f6ab var(--percentage), var(--c-nd-150) var(--percentage))
      border-box;
`;

type Props = { percentage: number };
export const MarketCreditExpirationGauge = ({ percentage }: Props) => {
  return (
    <Root style={{ '--percentage': `${percentage || 0}%` } as CSSProperties}>
      <img src={marketCredit} alt="" width={16} height={16} />
    </Root>
  );
};
